<template>
  <v-app class="background">
 
    <AppNavbar />
    <v-main class="background mt-8">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import AppNavbar from '@/components/CommonComponents/AppNavbar'

export default {
  name: "App",
  components: {
    AppNavbar
  },
  
  computed: {
  
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
  watch: {
    isIdle(val) {
      if(!val) {
        this.logout()
      }
    }
  },
  methods: {
    ...mapActions(['logoutAccount', 'logoutUser']),
    logout() {
      this.$store.dispatch('logoutAccount')
      this.$store.dispatch('logoutUser')
      this.$router.push('/')
    },
  
  }
};
</script>

<style lang="sass">
#app > div > header > div > button > span > i 
  font-size: 40px

</style>
